module.exports = __webpack_public_path__ + "img/contact_mobile.a2d4e3c0.svg";